import { MenuOutlined } from '@ant-design/icons'

const MenuIcon = MenuOutlined

export default MenuIcon
